import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ProveedorSesion } from './lib/sesion';
import { routeTree } from './routeTree.gen';
import { CargandoPantalla } from './shell/CargandoPantalla';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingComponent: CargandoPantalla,
  defaultPendingMs: 250,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const raiz = document.getElementById('app');
if (!raiz) throw new Error('Falta el elemento #app en index.html');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProveedorSesion>
        <RouterProvider router={router} />
      </ProveedorSesion>
    </QueryClientProvider>
  </StrictMode>,
);
